import { useState } from "react";
import { Link } from "react-router-dom";
import { Briefcase, ArrowUpRight } from "lucide-react";
import { useT } from "@/lib/i18n";

// Quiet, non-pushy teaser. Links to /opportunity for anyone curious — never interrupts
// the main plan-comparison flow.
export default function OpportunityTeaser() {
    const { t } = useT();
    return (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 py-10" data-testid="opportunity-teaser">
            <Link
                to="/opportunity"
                data-testid="opportunity-link"
                className="card-surface p-5 sm:p-6 flex items-center gap-4 group hover:border-emerald-500/40 transition"
            >
                <span className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-emerald-500/10 border border-emerald-500/30 text-emerald-300 shrink-0">
                    <Briefcase className="w-5 h-5" />
                </span>
                <div className="flex-1 min-w-0">
                    <div className="text-xs mono uppercase tracking-widest text-slate-400">
                        {t("opp_teaser_chip")}
                    </div>
                    <div className="mt-0.5 text-white font-semibold">
                        {t("opp_teaser_title")}
                    </div>
                    <div className="text-xs sm:text-sm text-slate-400">
                        {t("opp_teaser_sub")}
                    </div>
                </div>
                <ArrowUpRight className="w-5 h-5 text-slate-500 group-hover:text-emerald-300 transition" />
            </Link>
        </section>
    );
}
